// extracted by mini-css-extract-plugin
export default {"navbar__logo":"Logo_navbar__logo__rSZ1l"};